import { Banknote, CreditCard, QrCode, Ticket } from "lucide-react";

// Ícone e cor de cada forma pelo código/nome (o código real traz o id da
// loja: "dinheiro_<uuid>", por isso é regex e não igualdade). Cópia do que o
// pages/Mesas.js usa — o Mesas passa o dele; a retirada usa este.
export function visualForma(code = "", label = "") {
  const k = `${code} ${label}`.toLowerCase();
  if (/dinheiro|especie/.test(k)) return { icon: Banknote, color: "bg-green-500" };
  if (/pix/.test(k)) return { icon: QrCode, color: "bg-teal-500" };
  if (/credito|crédito/.test(k)) return { icon: CreditCard, color: "bg-blue-500" };
  if (/debito|débito/.test(k)) return { icon: CreditCard, color: "bg-purple-500" };
  if (/cart/.test(k)) return { icon: CreditCard, color: "bg-blue-500" };
  if (/vale|[^a-z]vr[^a-z]|[^a-z]va[^a-z]/.test(` ${k} `)) return { icon: Ticket, color: "bg-amber-500" };
  return { icon: CreditCard, color: "bg-slate-500" };
}
